import { pipe } from 'ramda';

import {
  buildCmsUrl,
  CMSApiBase,
  CMSDescription,
  CMSFaq,
  CMSGroupParams,
  CMSHowToParticipate,
  CMSImageBase,
  getResponseCMS,
} from './base';
import { request } from '@/api/base';
import { getResponseCamelization } from '@/helpers/api';

export interface ScratchGameMenuDataApi extends CMSApiBase {
  menu: {
    bg: CMSImageBase;
    character: CMSImageBase;
  };
}

export const scratchGameMenuCMS = (lang: string) =>
  request<ScratchGameMenuDataApi>({
    url: buildCmsUrl({
      path: 'scratch-game',
      lang,
      additionalParams: {
        'populate[0]': 'menu',
        'populate[1]': 'menu.bg',
        'populate[2]': 'menu.character',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<ScratchGameMenuDataApi>
    ),
  });

export interface LockedCardDescription extends CMSGroupParams {
  cardDescription: string;
}

export interface ScratchGameApi extends CMSApiBase {
  pageTitle: string;
  pageDescription: CMSDescription[];
  leftImg: CMSImageBase;
  rightImg: CMSImageBase;
  mobImg: CMSImageBase;
  leftDecorImg: CMSImageBase;
  rightDecorImg: CMSImageBase;
  promoCode: string;
  topBg: CMSImageBase;
  lockedCardTitle: string;
  lockedCardDescription: LockedCardDescription[];
  howToParticipateTitle: string;
  howToParticipate: CMSHowToParticipate[];
  faqTitle: string;
  faq: CMSFaq[];
  fivePlusDepCardTitle: string;
  fivePlusDepCardDescription: string;
}

export const scratchGameCMS = (lang: string) =>
  request<ScratchGameApi>({
    url: buildCmsUrl({
      path: 'scratch-game',
      lang,
      additionalParams: { populate: 'deep' },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<ScratchGameApi>
    ),
  });

export interface ScratchGamePageTitleApi extends CMSApiBase {
  pageTitle: string;
}

export const scratchGamePageTitleCMS = (lang: string) =>
  request<ScratchGamePageTitleApi>({
    url: buildCmsUrl({
      path: 'scratch-game',
      lang,
      additionalParams: {
        fields: 'page_title',
      },
    }),
    transformResponse: pipe(
      getResponseCamelization,
      getResponseCMS<ScratchGamePageTitleApi>
    ),
  });
